import React from 'react';
import { Trophy, X, Minus } from 'lucide-react';

interface GameResultProps {
  result: 'win' | 'lose' | 'draw';
  betAmount: number;
  onPlayAgain: () => void;
}

export function GameResult({ result, betAmount, onPlayAgain }: GameResultProps) {
  const resultConfig = {
    win: {
      icon: Trophy,
      title: 'Victory!',
      message: `You won ${betAmount * 2} coins!`,
      iconColor: 'text-yellow-400',
      bgGradient: 'from-green-600 to-emerald-500'
    },
    lose: {
      icon: X,
      title: 'Defeat',
      message: `You lost ${betAmount} coins`,
      iconColor: 'text-red-400',
      bgGradient: 'from-red-600 to-rose-500'
    },
    draw: {
      icon: Minus,
      title: 'Draw',
      message: 'Your bet has been returned',
      iconColor: 'text-blue-400',
      bgGradient: 'from-blue-600 to-cyan-500'
    }
  };

  const config = resultConfig[result];
  const Icon = config.icon;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className={`bg-gradient-to-br ${config.bgGradient} p-0.5 rounded-xl max-w-md w-full`}>
        <div className="bg-gray-900 p-8 rounded-lg text-center">
          <Icon className={`w-16 h-16 ${config.iconColor} mx-auto mb-4`} />
          <h2 className="text-3xl font-bold text-white mb-2">{config.title}</h2>
          <p className="text-gray-300 mb-6">{config.message}</p>
          <button
            onClick={onPlayAgain}
            className="px-6 py-3 bg-gradient-to-r from-yellow-600 to-amber-500 text-white rounded-lg
              hover:from-yellow-500 hover:to-amber-400 transition-colors font-serif"
          >
            Play Again
          </button>
        </div>
      </div>
    </div>
  );
}